module.exports = __webpack_public_path__ + "img/giphy-logo.261b7d09.gif";